import { render, staticRenderFns } from "./AccountManagementReportsTab.container.vue?vue&type=template&id=ab5dbabc&"
import script from "./AccountManagementReportsTab.container.vue?vue&type=script&lang=ts&"
export * from "./AccountManagementReportsTab.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports